import { z } from "zod";

export const personSchemaForAutoComplete = z.object({
    idUUID: z.string(),
    fullName: z.string().optional().nullable(),

    namePrefix: z.string().optional().nullable(),
    nameFirst: z.string().optional().nullable(),
    nameI: z.string().optional().nullable(),
    nameLast: z.string().optional().nullable(),
    nameSuffix: z.string().optional().nullable(),
    nameAKA: z.string().optional().nullable(),
    address: z.string().optional().nullable(),
    address2: z.string().optional().nullable(),
    city: z.string().optional().nullable(),
    state: z.string().optional().nullable(),
    zip: z.string().optional().nullable(),
    primaryPhoneNumber: z.string().optional().nullable(),
    email: z.string().optional().nullable(),
});
